import { useRef, useState, useEffect } from 'preact/hooks'
import dayjs from 'dayjs'
import Qs from 'qs'
import { kafkaLog, loginReq } from '../../api'
import ErrorMessage from '../ErrorMessage'

const AuthForm = ({ onClickForgot, loginInputRef }) => {
  const [error, setError] = useState(false)
  const passInput = useRef(null)

  useEffect(() => {
    if (loginInputRef.current) {
      loginInputRef.current.focus()
    }
  }, [loginInputRef])

  const resetError = () => {
    if (error) {
      setError('')
    }
  }

  const clickForgotPasswordHandler = () => {
    resetError()
    onClickForgot(true)
    logger()
    passInput.current.value = ''
    loginInputRef.current.value = ''
  }

  const submitHandler = (e) => {
    e.preventDefault()
    if (!loginInputRef.current.value || !passInput.current.value) {
      setError('Заполните все поля!')
      return
    }
    const data = new FormData()
    data.append('login', loginInputRef.current.value)
    data.append('password', passInput.current.value)
    loginReq(data)
      .then((res) => {
        if (res.data.code === 'ERROR') {
          setError(res.data.text)
          return
        }
        if (res.data.access === true && res.data.code === 'OK') {
          window.location.href = '/'
        }
        // eslint-disable-next-line no-console
      })
      .catch((e) => console.error(e))
      .finally(setError(''))
  }

  const logger = () => {
    const HOUR = 60
    let timezone = dayjs().utcOffset() / HOUR
    // eslint-disable-next-line prefer-const
    let [hour, minute] = String(timezone).split('.')

    if (minute) {
      minute = String((minute / 100) * 60)
    } else {
      minute = '00'
    }

    let timezonePrefix
    if (hour >= 0 && hour < 10) {
      timezonePrefix = '+0'
    } else if (hour >= 10) {
      timezonePrefix = '+'
    } else {
      timezonePrefix = ''
    }

    timezone = `${timezonePrefix}${hour}:${minute}`
    const logData = {
      topic: 'base_identity_actions',
      'action[eventType]': 'authorization',
      'action[eventCode]': 'click_forgot_password',
      'action[detail][sourceScreen]': window.location.host,
      'action[timezone]': timezone,
    }
    kafkaLog(Qs.stringify(logData))
  }

  return (
    <div className="personal-index">
      <div className="login_box">
        <form
          id="loginform"
          onSubmit={(e) => submitHandler(e)}
          className="login_form"
        >
          <div className="h2">Авторизация</div>
          <div className="personal-input">
            {error && <ErrorMessage text={error} />}
          </div>
          <div className="personal-input">
            <input
              value={loginInputRef?.current?.value}
              ref={loginInputRef}
              type="text"
              id="login"
              name="login"
              placeholder="Логин/Телефон"
              onInput={resetError}
            />
          </div>
          <div className="personal-input">
            <input
              ref={passInput}
              type="password"
              id="password"
              name="password"
              placeholder="Пароль"
              onInput={resetError}
            />
          </div>
          <div className="personal-input">
            <button type="submit" className="btm">
              Войти
            </button>
          </div>
          <div className="personal-input">
            <a href="#" onClick={clickForgotPasswordHandler}>
              Забыли пароль
            </a>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AuthForm
